import mock from './mock'

/* eslint-disable import/extensions */

// JWT
import './jwt'

// Keep the legacy mocks still consumed by the registered application routes.
import './data/apps/user'
import './data/pages/blog'
/* eslint-enable import/extensions */

mock.onAny().passThrough() // forwards the matched request over network
